import { clsx } from '../functions'
import { ReactNode } from 'react';
import './button.css'
import { inputOnKeyUp } from "../functions.ts";

export function Button(props:{style?: React.CSSProperties, label: string, disabled?: boolean, onClick: ()=>void}){
  return <div
  role="button"
  aria-label={props.label}
  inert={props.disabled}
  tabIndex={0}
  style={props.style} 
  className={clsx("button", props.disabled && "button--disabled")} 
  onClick={()=>{props.onClick()}}
  onKeyUp={(event)=>inputOnKeyUp(event, props.onClick)}
  ><span className="button__label">{props.label}</span></div>
}

export function ButtonOutline(props:{style?: React.CSSProperties, label: string, disabled?: boolean, onClick: ()=>void}){
  return <div 
  role="button"
  aria-label={props.label}
  inert={props.disabled}
  tabIndex={0}
  className={clsx("button-outline", props.disabled && "button--disabled")} 
  onClick={()=>{props.onClick()}}
  onKeyUp={(event)=>inputOnKeyUp(event, props.onClick)}
  ><span className="button__label">{props.label}</span></div>
}

export function ButtonRow(props:{children: ReactNode}){
  return <div className="button-row">{props.children}</div>
}
//   interface SidebarOptionsButtonOptions{
//     label: string,
//     onClick: ()=>void,
//   }

//   function SidebarOptionsButton(props:{label: string, disabled?: boolean, options: Array<SidebarOptionsButtonOptions>}){
//     const [open, setOpen] = useState(false);
//     return <div>
//           <div className={"user-select-none p-4 hover:bg-sky-400 text-white cursor-pointer" + (open ? " bg-sky-700 " : " bg-sky-600 ") + (props.disabled ? " opacity-50 bg-gray-400 text-gray-100 pointer-events-none" : "")} 
//           onClick={()=>{
//             setOpen(!open)
//           }}>{props.label}</div>
//           <div className={"flex flex-col dropdown" + (open ? "dropdown--open" : "")}>
//             {props.options.map((option)=><SidebarButton key={option.label} label={option.label} onClick={()=>{
//               option.onClick();
//               setOpen(false);
//             }} />)}
//           </div>
//       </div>
//   }